import Swal from "sweetalert2";
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

export default {
    name: 'Drivers',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        if (this.loginDetails) {
            if (this.loginDetails.userType != 1 && this.loginDetails.userType != 40)
                this.logout();
        } else {
            this.logout();
        }
        this.GetInfo(this.pageNo);
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
  ,
 
      
    },

    data() {
        return {
            selectedDriver: null,
            viewLoading: false,
            viewError: null,
            todayDate: new Date().toISOString().split('T')[0],
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            DriverStatus: null,
          Statistics : {},
            ScreenTitle: '   السائقين الموقوفين ',
            ScreenTitleSingle: '   سائق الموقوف ',
            ScreenTitleSingleAl: 'السائق ',

            Info: [],
          

            SelectedItem: null,
            SuspendReason: '',
            SuspendDriverId: null,

 
        };
    },

    methods: {    
        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) this.pageNo = 1;
            if (!this.Search) this.$blockUI.Start();
            const schoolId = this.loginDetails && this.loginDetails.userType == 40
                ? this.getSchoolId() : null;
            this.$http.GetSuspended(this.pageNo, this.pageSize, this.Search, schoolId)
                .then(response => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                    this.Statistics = response.data.statistics || {};
          
                })
                .catch(() => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.pages = 0;
                    this.Info = [];
                });
        },
        badgeStatusClass(status) {
            if (status === 1) return 'bg-warning-subtle text-warning';
            if (status === 2) return 'bg-success-subtle text-success';
            if (status === 3) return 'bg-danger-subtle text-danger';
            return 'bg-secondary-subtle text-secondary';
        }
        , 
        applyFilters() {
            this.pageNo = 1;
            this.GetInfo(this.pageNo);
        },

        onPageSizeChanged(size) {
            this.pageSize = size;
            this.pageNo = 1;
            this.GetInfo();
        },
        driverStatusLabel(status) {
            if (status === 1) return 'قيد المراجعة';
            if (status === 2) return 'موافق عليه';
            if (status === 3) return 'مرفوض';
            if (status === 9) return 'محذوف';
            return status;
        },

        async openViewDialog(id) {
            try {
                this.viewLoading = true;
                this.viewError = null;
                this.selectedDriver = null;

                // عدلي المسار حسب راوت مشروعك
                const res = await
                    this.$http.GetDriverById(id)

               

                this.selectedDriver = res.data;
            } catch (err) {
            
                this.viewError =
                    err?.response?.data?.message ||
                    err?.response?.data ||
                    "حدث خطأ أثناء جلب بيانات السائق";
            } finally {
                this.viewLoading = false;
            }
        },
        OpentEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.UsersId = item.usersId || null;
            this.ruleForm.FirstName = item.firstName || (item.name ? item.name.split(' ')[0] : '');
            this.ruleForm.FatherName = item.fatherName || '';
            this.ruleForm.SirName = item.sirName || '';
            this.ruleForm.Phone = item.phone || '';
            this.ruleForm.PassportExpiry = item.passportExpiry || null;
            this.ruleForm.PassportImage = '';
            this.ruleForm.PassportImageName = '';
            this.ruleForm.Descriptions = item.descriptions || '';
        },

        SelectPassportImage(file) {
            if (!file) return;
            if (file.type.substring(0, 5) !== 'image') {
                this.$helper.ShowMessage('error', 'خطأ', 'اختر صورة');
                return;
            }
            const $this = this;
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                $this.ruleForm.PassportImageName = file.name;
                $this.ruleForm.PassportImage = reader.result;
            };
        },

        submitEditForm(formName) {
            const form = this.$refs[formName];
            if (!form) return;
            form.validate((valid) => {
                if (valid) {
                    const body = {
                        Id: Number(this.ruleForm.Id),
                        UsersId: this.ruleForm.UsersId || null,
                        FirstName: this.ruleForm.FirstName,
                        FatherName: this.ruleForm.FatherName || null,
                        SirName: this.ruleForm.SirName || null,
                        Phone: this.ruleForm.Phone,
                        PassportExpiry: this.ruleForm.PassportExpiry || null,
                        PassportImage: this.ruleForm.PassportImage || null,
                        PassportImageName: this.ruleForm.PassportImageName || null,
                        Descriptions: this.ruleForm.Descriptions || null
                    };
                    this.$blockUI.Start();
                    this.$http.EditDrivers(body)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo(this.pageNo);
                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('CloseEdit');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع');
                        });
                } else {
                    this.$helper.showSwal('warning');
                }
            });
        },

        Approve(Id) {
            Swal.fire({ title: 'تأكيد الموافقة', text: 'هل أنت متأكد من الموافقة على السائق؟', icon: 'question', customClass: { confirmButton: 'btn btn-primary' }, buttonsStyling: false, confirmButtonText: 'نعم' })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.$blockUI.Start();
                        this.$http.ApproveDriver(Id)
                            .then(() => { this.$blockUI.Stop(); this.$helper.ShowMessage('success', 'عملية ناجحة', 'تمت الموافقة'); this.GetInfo(this.pageNo); })
                            .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
                    }
                });
        },

        Reject(Id) {
            Swal.fire({ title: 'تأكيد الرفض', text: 'هل أنت متأكد من رفض السائق؟', icon: 'question', customClass: { confirmButton: 'btn btn-primary' }, buttonsStyling: false, confirmButtonText: 'نعم' })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.$blockUI.Start();
                        this.$http.RejectDriver(Id)
                            .then(() => { this.$blockUI.Stop(); this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم الرفض'); this.GetInfo(this.pageNo); })
                            .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
                    }
                });
        },

        ChangeActive(Id) {
            this.$blockUI.Start();
            this.$http.ChangeActiveDriver(Id)
                .then(() => { this.$blockUI.Stop(); this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم تغيير الحالة'); this.GetInfo(this.pageNo); })
                .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
        },

        openSuspendModal(Id) {
            this.SuspendDriverId = Id;
            this.SuspendReason = '';
        },

        submitSuspend() {
            if (!this.SuspendReason || !this.SuspendDriverId) {
                this.$helper.ShowMessage('error', 'خطأ', 'يرجى إدخال سبب إيقاف الحساب');
                return;
            }
            this.$blockUI.Start();
            this.$http.SuspendDriver({ DriverId: this.SuspendDriverId, Reason: this.SuspendReason })
                .then(() => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم إيقاف حساب السائق');
                    this.SuspendDriverId = null;
                    this.SuspendReason = '';
                    this.$helper.DestroyElemntById('CloseSuspend');
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
        },

        CancelSuspend(Id) {
            Swal.fire({ title: 'رفع إيقاف الحساب', text: 'هل أنت متأكد من رفع الإيقاف عن حساب السائق؟', icon: 'question', customClass: { confirmButton: 'btn btn-primary' }, buttonsStyling: false, confirmButtonText: 'نعم' })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.$blockUI.Start();
                        this.$http.CancelSuspendDriver(Id)
                            .then(() => { this.$blockUI.Stop(); this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم رفع إيقاف الحساب'); this.GetInfo(this.pageNo); })
                            .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
                    }
                });
        },

        Delete(Id) {
            Swal.fire({ title: 'تأكيد الحذف', text: 'هل أنت متأكد من حذف السائق؟', icon: 'question', customClass: { confirmButton: 'btn btn-primary' }, buttonsStyling: false, confirmButtonText: 'نعم' })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.$blockUI.Start();
                        this.$http.DeleteDrivers(Id)
                            .then(() => { this.$blockUI.Stop(); this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم الحذف'); this.GetInfo(this.pageNo); })
                            .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
                    }
                });
        }
    }
};
